(function() {
    function funcReady() {
        $('.KRC0021').buildCommonUI();

        vcui.require(['ui/carousel'], function () {
            $('.KRC0021').find('.ui_carousel_slider').on('carouselinit',function(e, carousel, data){

                vcui.require(['ui/videoBox','ui/youtubeBox'], function(){
                    $('.KRC0021').find('.animation-box').vcVideoBox();
                    $('.KRC0021').find('.youtube-box').vcYoutubeBox();
                });

            }).vcCarousel({
                responsive: [
                    {
                        breakpoint: 10000,
                        settings: 'unslick'
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            infinite: false,
                            dots: true,
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        });
    }

    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'CONTENTS', name: 'KRC0021', isFirstLoad: false, fn: function () {
                if(!document.querySelector('.KRC0021')) return false;
                funcReady();
            }
        });
    }

    SAVE_COMPONENT_PDP_DOM_MNG();

    $(window).ready(function(){
        SAVE_COMPONENT_PDP_DOM_MNG();

        if(!document.querySelector('.KRC0021')) return false;
        funcReady();
    });
})();

